var _defs, _g, _path, _g2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEduIconos7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 293,
    zoomAndPan: "magnify",
    viewBox: "0 0 219.75 198.749996",
    height: 265,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "76b8785281"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74 69 L 219.488281 69 L 219.488281 197.75 L 74 197.75 Z M 74 69 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7cc7745f2e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74 69 L 219.488281 69 L 219.488281 197.75 L 74 197.75 Z M 74 69 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76b8785281)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5d37e",
    d: "M 74.628906 69.0625 L 219.21875 94.132812 L 144.703125 197.996094 Z M 74.628906 69.0625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.0997419, -0.139028, 0.123165, 0.0883625, -997.374162, 1310.352573)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 9498.192198 721.586746 L 9871.737623 1593.036719 L 9124.644906 1593.043216 Z M 9498.192198 721.586746 ",
    stroke: "#000000",
    strokeWidth: 14.07,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7cc7745f2e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5d37e",
    d: "M 74.628906 69.0625 L 219.21875 94.132812 L 144.703125 197.996094 Z M 74.628906 69.0625 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(0.0997419, -0.139028, 0.123165, 0.0883625, -997.374162, 1310.352573)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 9498.192198 721.586746 L 9871.737623 1593.036719 L 9124.644906 1593.043216 Z M 9498.192198 721.586746 ",
    stroke: "#000000",
    strokeWidth: 14.07,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEduIconos7);
export default __webpack_public_path__ + "static/media/edu_iconos_7.ca1d217ef343ba251bcd7aea2ac382cd.svg";
export { ForwardRef as ReactComponent };